/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React, { useEffect, useRef, useState} from "react"
// Redux Toolkit
import { useDispatch } from "react-redux";
// BASE components
import BASEPageSimple from "../../../@BASE/core/BASEPageSimple";
// Material-UI
import { styled } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
// Custom Components
import ListingHeader from "../../shared-components/headers/ListingHeader";
import UsersList from "./listing/UsersList";
// actions
import useGroupedListing from "../../actions/useGroupedListing";
import { getListing } from "../../actions/index";
import { resetNavigation } from "../../store/BASE/navigationSlice";

const Root = styled(BASEPageSimple)(({ theme }) => ({
  "& .BASEPageSimple-header": {
    backgroundColor: theme.palette.background.royalBlue,
    color: theme.palette.getContrastText(theme.palette.primary.main),
  },
}));

function UsersPage() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const pageLayout = useRef(null);

  const { groupedData, searchTerm, setSearchTerm } = useGroupedListing(users, 'last_name', ['first_name', 'last_name', 'email', 'role']);

  // fetch Users
  const fetchUsers = async () => {
    try {
      const response = await dispatch(getListing('users')()).unwrap();
      setUsers(response);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  // get data from API on page load
  useEffect(() => {
    // get users
    fetchUsers();
    // reset navigation
    dispatch(resetNavigation());
  }, [dispatch]);
  // 
  if (!users || loading) {
    return (
      <CircularProgress />
    )
  }

  return (
    <Root
      header={<ListingHeader resource="Users" searchTerm={searchTerm} setSearchTerm={setSearchTerm} />}
      content={<UsersList users={groupedData} />}
      ref={pageLayout}
      scroll="normal"
    />
  );
}

export default UsersPage;
